module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-0021.8cadd390.jpg";